
import { createContext, useContext, useEffect, useState } from "react";
import { supabase } from "@/lib/supabase";
import { DEFAULT_CONTENT } from "@/data/content";

const ContentContext = createContext(null);

export function ContentProvider({ children }) {
  const [content, setContent] = useState(DEFAULT_CONTENT);
  const [loading, setLoading] = useState(true);

  const refresh = async () => {
    try {
      const { data, error } = await supabase
        .from("portfolio_content")
        .select("content")
        .eq("id", 1)
        .maybeSingle();

      if (error) throw error;

      if (data?.content && Object.keys(data.content).length > 0) {
        setContent({ ...DEFAULT_CONTENT, ...data.content });
      }
    } catch (error) {
      console.error("Could not load portfolio content:", error.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    refresh();
  }, []);

  return (
    <ContentContext.Provider value={{ content, refresh, loading }}>
      {children}
    </ContentContext.Provider>
  );
}

export function useContent() {
  const ctx = useContext(ContentContext);
  return ctx ? ctx.content : DEFAULT_CONTENT;
}

export function useContentRefresh() {
  const ctx = useContext(ContentContext);
  return (ctx && ctx.refresh) || (() => {});
}
